// extracted by mini-css-extract-plugin
export default {"spinner":"Ah","rotator":"Bh","container":"Ch","inheritColor":"Dh","path":"Eh","dash":"Fh"};